module.exports = __webpack_public_path__ + "assets/media/checkmark.090283d3.svg";